import { ArticleHeading1, ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface ICallbackRequestBlockProps {
  callbackButton: React.ReactNode;
}

export const CallbackRequestBlock: React.FC<ICallbackRequestBlockProps> = ({ callbackButton }) => {
  return (
    <div className={styles['container']} data-testid="CallbackRequestBlock">
      <div>
        <div className={styles['heading']}>
          <ArticleHeading1>Оставьте заявку на&nbsp;звонок</ArticleHeading1>
        </div>
        <ArticleParagraph1 as="p">Застройщик перезвонит в&nbsp;удобное время и&nbsp;всё расскажет</ArticleParagraph1>
      </div>
      <div className={styles['actions']}>{callbackButton}</div>
    </div>
  );
};
